import AdminGroupList from '@/components/Group/AdminGroupList'
import AdminGroupForm from '@/components/Group/AdminGroupForm'
import AdminGroupDetail from '@/components/Group/AdminGroupDetail'

let GroupRouter = [
{
  path: '/admin/group',
  name: 'AdminGroupList',
  component: AdminGroupList,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/group/new',
  name: 'AdminGroupNew',
  component: AdminGroupForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/group/:id/edit',
  name: 'AdminGroupEdit',
  component: AdminGroupForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/group/:id',
  name: 'AdminGroupDetail',
  component: AdminGroupDetail,
  meta: {
    requiresAuth: true
  }
}]

export default GroupRouter


// WEBPACK FOOTER //
// ./src/components/Group/router.js